import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  connect() {
    this.selectedLevelOneId = null;
    this.selectedLevelTwoId = null;
    this.currentOffset = 0;
    this.searchValue = '';
    this.abortController = null;
    this.requestId = 0;

    const showLevelOne = this.element.dataset.showLevelOne === 'true'
    const showLevelTwo = this.element.dataset.showLevelTwo === 'true'

    if (!showLevelOne && showLevelTwo) {
      this.loadLevelTwos()
    } else if (!showLevelOne && !showLevelTwo) {
      this.autoLoadLevelTwoUsers()
    }

    const searchInput = document.querySelector('#appUserSearch');
    if (searchInput) {
      let timeout;
      searchInput.addEventListener('keyup', () => {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          this.searchValue = searchInput.value;
          this.currentOffset = 0;
          this.loadAppUsers(true);
        }, 300);
      });
    }
  }

  autoLoadLevelTwoUsers() {
    fetch('/app_user_hierarchy/level_twos')
      .then(res => res.json())
      .then(data => {
        if (data.length > 0) {
          this.selectedLevelTwoId = data[0].id
          this.loadAppUsers(true)
        }
      })
  }

  loadLevelTwos(levelOneId = null) {
    const url = levelOneId
      ? `/app_user_hierarchy/level_twos?level_one_id=${levelOneId}`
      : `/app_user_hierarchy/level_twos`

    fetch(url)
      .then(res => res.json())
      .then(data => this.renderLevelTwoTable(data))
  }

  levelOneClick(event) {
    event.preventDefault()
    const id = event.currentTarget.dataset.levelOneId
    this.selectedLevelOneId = id

    document.querySelectorAll('[data-level-one-id]').forEach(el => {
    el.closest('tr').classList.remove('bg-opacity-25', 'bg-primary')
    })
    event.currentTarget.closest('tr').classList.add('bg-opacity-25', 'bg-primary')

    this.selectedLevelTwoId = null

    document.querySelector('#levelTwoTable tbody').innerHTML = ''
    document.querySelector('#appUserActions').classList.add('d-none')
    document.querySelector('#appUserNewAction').classList.add('d-none')
    this.resetAppUserTable()

    fetch(`/app_user_hierarchy/level_twos?level_one_id=${id}`)
    .then(res => res.json())
    .then(data => this.renderLevelTwoTable(data))
  }

  renderLevelTwoTable(data) {
    const tbody = document.querySelector('#levelTwoTable tbody')
    tbody.innerHTML = ''

    if (data.length === 0) {
    tbody.classList.remove('border-bottom')
    tbody.innerHTML = '<tr class="mt-1"><td colspan="2" class="text-center text-muted py-5">該当データはありません。</td></tr>'
    return
    }
    tbody.classList.add('border-bottom')
    data.forEach(item => {
      tbody.innerHTML += `
        <tr class="cursor-pointer" data-level-two-id="${item.id}" data-level-two-code="${item.level_two_code}" data-action="click->app-user-hierarchy#levelTwoClick">
          <td class="fs-6 p-4">
            <span class="text-primary-two fs-5 fw-bold d-block">${item.level_two_code}</span>
            <span class="truncate-text">${item.name}</span>
          </td>
          <td class="text-end pe-4">
            <div class="border border-primary border-dashed rounded w-70 d-inline-block py-2 px-4">
              <div class="fs-3 text-primary fw-bolder text-end">
                ${item.app_users_count}
              </div>
              <div class="fw-bolder fs-8 text-gray-700 text-end">
                アプリユーザー数
              </div>
            </div>
          </td>
        </tr>
      `
    })
  }

  levelTwoClick(event) {
    event.preventDefault()

    document.querySelectorAll('[data-level-two-id]').forEach(el => {
      el.closest('tr').classList.remove('bg-opacity-25', 'bg-primary')
    })
    event.currentTarget.closest('tr').classList.add('bg-opacity-25', 'bg-primary')

    this.isLoading = false
    this.currentOffset = 0
    this.searchValue = ''
    this.selectedLevelTwoId = event.currentTarget.dataset.levelTwoId

    // show new btn, hide app user actions
    document.querySelector('#appUserNewAction').classList.remove('d-none')
    document.querySelector('#appUserNewBtn').href = `/app_users/new?org_code=${event.currentTarget.dataset.levelTwoCode}`
    document.querySelector('#appUserActions').classList.add('d-none')

    document.querySelector('#appUserSearch').value = ''
    this.loadAppUsers(true)
  }

  loadAppUsers(reset = false) {
    if (!this.selectedLevelTwoId) return
    if (this.isLoading && !reset) return

    const levelTwoId = this.selectedLevelTwoId
    this.isLoading = true

    fetch(`/app_user_hierarchy/app_users?level_two_id=${levelTwoId}&offset=${this.currentOffset}&search=${this.searchValue}`)
    .then(res => res.json())
    .then(data => {
        if (levelTwoId !== this.selectedLevelTwoId) return

        const tbody = document.querySelector('#appUserTable tbody')

        if (reset) tbody.innerHTML = ''

        if (reset && data.data.length === 0) {
        tbody.classList.remove('border-bottom')
        tbody.innerHTML = `<tr><td colspan="2" class="text-center text-muted py-5">該当データはありません。</td></tr>`
        this.isLoading = false
        return
        }
        tbody.classList.add('border-bottom')
        let rows = ''
        data.data.forEach(user => {
            rows += `
              <tr class="cursor-pointer" data-user-id="${user.id}" data-action="click->app-user-hierarchy#appUserClick">
                <td class="fs-6 ps-4">
                  <span class="text-primary-two fs-5 fw-bold d-block">${user.org_code}-${user.app_user_code}</span>
                  ${user.first_name} ${user.last_name}
                </td>
              </tr>
            `
          })

        tbody.insertAdjacentHTML('beforeend', rows)

        if (data.has_more) {
        this.currentOffset = data.next_offset
        this.isLoading = false
        setTimeout(() => this.loadAppUsers(), 1)
        } else {
        this.isLoading = false
        }
    })
  }

  appUserClick(event) {
    event.preventDefault()

    document.querySelectorAll('[data-user-id]').forEach(el => {
      el.classList.remove('bg-opacity-25', 'bg-primary')
    })
    event.currentTarget.classList.add('bg-opacity-25', 'bg-primary')

    const userId = event.currentTarget.dataset.userId

    document.querySelector('#appUserNewAction').classList.add('d-none')
    document.querySelector('#appUserActions').classList.remove('d-none')
    document.querySelector('#appUserViewBtn').href = `/app_users/${userId}`
    document.querySelector('#appUserEditBtn').href = `/app_users/${userId}/edit`
    document.querySelector('#deleteAppUserForm').action = `/app_users/${userId}`
  }

  resetAppUserTable() {
    this.currentOffset = 0
    this.searchValue = ''
    this.selectedLevelTwoId = null

    const tbody = document.querySelector('#appUserTable tbody')
    tbody.classList.remove('border-bottom')
    tbody.innerHTML = `
    <tr>
        <td colspan="2" class="text-center text-muted py-5">
        該当データはありません。
        </td>
    </tr>
    `
    const searchInput = document.querySelector('#appUserSearch')
    if (searchInput) searchInput.value = ''
  }

}